const referralStatus = Object.freeze({
  New: 3092,
  Submitted: 3093,
  Completed: 3094,
  Related: 3097,
  Inactive: 3113
});

export default referralStatus;
